export enum FeatureFlagNames {
  // Offers is for the homepage banner, promoted destinations is for the search and promotions api
  OFFERS = "hsbc-offers",
  PROMOTED_DESTINATIONS_PREFIX = "hsbc-promoted-destinations",

  CHAT_SUPPORT = "cx-product-chat-support-ui",
  BEST_PRICE_GUARANTEE = "best-price-guarantee",
  DESKTOP_COMING_SOON = "desktop-coming-soon",
  DISABLE_BIN_CHECK = "disable-bin-check",
  DISABLE_CARS = "disable-cars",
  DISABLE_HOTELS = "disable-hotels",
  DISABLE_FLIGHTS = "disable-flights",
  ENABLE_CFAR = "enable-cfar",
  ENABLE_DISRUPTION = "enable-disruption",
  ENABLE_HOTELS_MULTIROOM = "enable-hotels-multiroom",
  ENABLE_HOTEL_DUPLICATE_BOOKING_WARNING = "enable-hotel-duplicate-booking-warning",
  ENABLED_PRICE_PREDICTION = "enable-price-prediction",
  HOTEL_MEAL_PLANS_EXPAND_ALL = "hotel_meal_plans_expand_all",
  HOTELS_STRIKETHROUGH_PRICE = "hsbc-hotels-strikethrough-price",
  SHOW_EAN_COMPLIANCY_CONTENT = "show-ean-compliancy-content",

  MAINTENANCE = "hsbc-maintenance",

  PERCENT_CASHBACK_OFFER_MERCHANDISING = "hsbc-sg-air-earn-percent-cashback",
  SHOW_WALLET_CREDIT_MERCHANDISING_BANNER = "show-wallet-credit-merchandising-banner",
  SHOW_MERCHANDISING_PAY_WITH_POINTS_BANNER = "show-merchandising-pay_with_points-banner",
  SHOW_MERCHANDISING_PAY_WITH_POINTS_PRICE = "show-merchandising-pay_with_points-price",
  SHOW_MERCHANDISING_EXTENDED_ENHANCED_BURN = "show-merchandising-extended-enhanced-burn",
  MAP_SEARCH_BOUNDING_BOX = "map-search-bounding-box",

  SHOW_DISABLED_3DS_NOTICE = "show-disabled-3ds-notice",

  // cx-product
  AIR_SELF_SERVE_CORE_EXCHANGE = "air-self-serve-core-exchange",

  ENABLE_PRICE_WATCH = "enable-price-watch",

  // Per-tenant overrides for which fields are shown and required in the
  // flights traveler form. JSON payload shape: see
  // `AirTravelerFormExceptionFlag` in @hsbc/flights. Only hsbc-in is wired
  // for now — add sibling entries when the same flag rolls out to other
  // tenants.
  AIR_TRAVELER_FORM_EXCEPTION_HSBC_IN = "hsbcin-air-traveler-form-exception",

  // Homepage notice banner. JSON payload shape: see `NoticesContainer` in
  // the ConnectedNoticeBanner component. Each HSBC tenant configures its own
  // payload in its LaunchDarkly project under this shared flag key.
  IMPORTANT_NOTICE = "hsbc-important-notice",
}
